export const lessThan = {
  id: 'lt',
  value: 'Lt',
};

export const greaterThanOrEqualTo = {
  id: 'gte',
  value: 'Gte',
};
